import { Typography } from "@mui/material";
import { TypographyProps } from "../types/prop-types";

const SmallText = ({ sx, center, children, color = "" }: TypographyProps) => (
  <Typography
    variant="body2"
    sx={{
      mb: "1%",
      ...sx,
      textAlign: center ? "center" : "unset",
    }}
    color={color}
  >
    {children}
  </Typography>
);
export default SmallText;
